import { MIXPANEL_TOKENS } from './mixpanel-tokens';
import { parseBooleanEnv } from './utils';

export const environment = {
  apiBaseUrl: 'https://api.sbv360.com',
  reportsApiUrl: 'https://report-generator-api-prod.azurewebsites.net',
  chatPublicKey: '7j2r5n773wxu',
  environment: 'prod',
  mixpanelToken: MIXPANEL_TOKENS.PRODUCTION as string | undefined,
  enablePBJ: parseBooleanEnv(process.env.NX_FEATURE_FLAG_PBJ_ENABLED, false),
};
